import styles from './styles/Items.icons.module.scss';
import React from 'react';
import { useAlgoliaAppContext } from '../../hooks/useAlgoliaAppContext';
import { useAlgoliaDataContext } from '../../hooks/useAlgoliaDataContext';
import { SEARCH_PARAM_KEY_PAGE_NUMBER, SEARCH_PARAM_KEY_TYPE } from '../../constants/searchParamKeys';
import { FACET_KEY_TYPES } from '../../constants/facetKeys';
import { Link, useParams } from 'react-router-dom';
import { Ssvg } from '../../../Components/react/Ssvg';
import { getLayoutIcon } from '../../../js/helpers/getLayoutIcon';
import { useSearchParamsCopy } from '../../../hooks/useSearchParamsCopy';
export const ItemsTypes = () => {
    const { facets } = useAlgoliaDataContext();
    const { medium, handle } = useParams();
    const { pagePath } = useAlgoliaAppContext();
    const [searchParams] = useSearchParamsCopy();
    const activeValue = searchParams.get(SEARCH_PARAM_KEY_TYPE);
    searchParams.delete(SEARCH_PARAM_KEY_PAGE_NUMBER);
    let pathname = `/${pagePath}`;
    if (handle !== undefined) {
        pathname += `/${handle}`;
    }
    if (medium !== undefined) {
        pathname += `/${medium}`;
    }
    return (React.createElement("ul", { "data-cy-test": 'CollectionFilter-Types', className: `list:none d:grid ${styles.items}` }, facets[FACET_KEY_TYPES].map(({ value, label }) => {
        const isActive = activeValue === value;
        const itemStateClass = isActive
            ? `bxsh:2 ${styles.itemActive}`
            : '';
        const title = label === 'Multiple'
            ? React.createElement("span", null,
                React.createElement("span", { className: "text:nowrap" }, "Multi-Panel"),
                " Canvas")
            : label;
        if (isActive) {
            searchParams.delete(SEARCH_PARAM_KEY_TYPE);
        }
        else {
            searchParams.set(SEARCH_PARAM_KEY_TYPE, value);
        }
        searchParams.sort();
        const searchParamsStr = searchParams.toString();
        return (React.createElement("li", { key: value },
            React.createElement(Link, { className: `btn:cleared w:100p bdrs:1 text:center text:uppercase d:flex fd:column ai:center jc:center trs:all:300 ov:h ${styles.item} ${itemStateClass}`, to: {
                    pathname,
                    ...(searchParamsStr.length > 0 && { search: `?${searchParamsStr}` })
                } },
                React.createElement(Ssvg, { icon: getLayoutIcon(value), className: `d:block ${styles.itemIcon}` }),
                React.createElement("span", { className: `d:flex ai:center ${styles.itemTitle}` }, title))));
    })));
};
